import { AxiosInstance } from 'axios'
import * as qs from 'querystring'
import { pro } from './mode'
import _createAPI from './_createAPI'

let host = 'https://api.mangoebike.com'

if (!pro || process.env.NODE_ENV !== 'production') {
  // host = 'http://hi.mangoebike.cc:9011';
  host = 'http://localhost:9020'
  if (window.location.search.length > 0) {
    const query = qs.parse(window.location.search.slice(1))
    if (query.mangoHost) {
      host = query.mangoHost as string
    }
  }
}

if (process.env.REACT_APP_ENV === 'staging') {
  host = 'https://api.staging.mangoebike.cc'
}

export default _createAPI(host, 'admin', 'v1') as AxiosInstance



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/api/v1.ts